import * as React from 'react';
import { Image, StyleSheet, View } from 'react-native';

import color from '../../style/color';
import { useWindowSize } from '../../style/utils';

const logo = { uri: '/assets/images/logos/logo-with-title.png' };

export default function AuthCard({ children }: { children: React.ReactNode }) {
    const size = useWindowSize();
    return (
        <View style={[styles.container, { height: size.height }]}>
            <View style={styles.containerLogo}>
                <Image source={logo} style={styles.imageLogo} />
            </View>
            <View style={styles.containerContent}>{children}</View>
        </View>
    );
}

const styles = StyleSheet.create({
    container: {
        flex: 1,
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: color.linkWaterLight,
    },
    containerLogo: {
        position: 'absolute',
        top: 54,
    },
    containerContent: {
        width: 440,
        paddingHorizontal: 32,
        paddingVertical: 48,
        backgroundColor: color.white,
        borderRadius: 8,
        shadowColor: '#000',
        shadowOffset: { width: 0, height: 0 },
        shadowOpacity: 0.06,
        shadowRadius: 12,
    },
    imageLogo: {
        width: 114,
        height: 55,
        resizeMode: 'contain',
    },
});
